import Splide from '@splidejs/splide';
// import AutoScroll from '@splidejs/splide-extension-auto-scroll';

document.addEventListener('DOMContentLoaded', function () {

  if (document.querySelector('.splide.topMv-slide')) {
    new Splide('.splide.topMv-slide', {
      type: 'fade',
      interval: 5000,
      pagination: false,
      autoplay: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      rewind: true,
      arrows: false,
    }).mount();
  }

  if (document.querySelector('.sec03-slider')) {
    new Splide('.sec03-slider', {
      type: 'loop',
      perPage: 1,
      arrows: true,
      pagination: true,
    }).mount();
  }

});